import React, { useState, useEffect, useRef } from "react";
import iconsMapping from "../../assets/icons/iconsMapping";
import { NavLink } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false);
    const [navbarBG, setNavbarBG] = useState(false);
    const navRef = useRef(null);

    useEffect(() => {
        const changeNavbarBG = () => {
        setNavbarBG(window.scrollY > 1);
        };

        window.addEventListener("scroll", changeNavbarBG);
        return () => window.removeEventListener("scroll", changeNavbarBG);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
        if (navRef.current && !navRef.current.contains(event.target)) {
            setToggleMenu(false);
        }
        };

        if (toggleMenu) {
        document.addEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [toggleMenu]);

    const closeMenu = () => {
        setToggleMenu(false);
    };

    return (
        <header className={`Header ${navbarBG ? "Navbar_Color_Scroll" : ""}`}>
            <nav className="Navbar" ref={navRef}>
                <NavLink to="/" className="Logo" onClick={closeMenu}>
                LB
                </NavLink>

                <div className={`nav_links ${toggleMenu ? "active" : ""}`} id="nav_links">
                <img
                    src={iconsMapping.close}
                    alt="Close"
                    onClick={closeMenu}
                    className="close-icon"
                />

                <ul>
                    <li>
                    <NavLink
                        to="/"
                        end
                        onClick={closeMenu}
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                    >
                        Home
                    </NavLink>
                    </li>

                    <li>
                    <NavLink
                        to="/about"
                        onClick={closeMenu}
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                    >
                        About
                    </NavLink>
                    </li>

                    <li>
                    <NavLink
                        to="/experience"
                        onClick={closeMenu}
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                    >
                        Experience
                    </NavLink>
                    </li>

                    <li>
                    <NavLink
                        to="/research"
                        onClick={closeMenu}
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                    >
                        Research
                    </NavLink>
                    </li>

                    {/* <li>
                    <NavLink
                        to="/contact"
                        onClick={closeMenu}
                        className={({ isActive }) => (isActive ? "active-link" : "")}
                    >
                        Contact
                    </NavLink>
                    </li> */}
                </ul>
                </div>

                <img
                src={iconsMapping.menu}
                alt="Menu"
                onClick={() => setToggleMenu(true)}
                className="menu-icon"
                />
            </nav>
        </header>
    );
};

export default Navbar;